import { Observable } from 'rxjs'
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { OrgHierarchy } from '../models/orgHeirarchy'
import { CommonGateway } from '../gateways/common-gateway'
import { UrlModel } from '../models/url-model'
import { GoodStandingModel } from '../models/good-standing-model'

@Injectable()
export class NetworkCommonGateway extends CommonGateway {
    constructor(private http: HttpClient) {
        super()
    }
    getOrgHierarchy(orgId: number): Observable<OrgHierarchy[]> {
        let getURL = '../api/GetOrgHeirarchy/' + orgId
        return this.http.get<OrgHierarchy[]>(getURL)
    }

    getGoodStandingStatus(userProfileId: number, planYear: string): Observable<boolean> {
        if (userProfileId == null) userProfileId = 0
        //if (planYear == "0")
        //    planYear = "2018"

        let getURL = '../api/isAgentGoodStanding/' + userProfileId + '/' + planYear
        return this.http.get<boolean>(getURL)
    }

    getGlobalLinks(orgId: number, planYear: string): UrlModel[] {
        var xhr = new XMLHttpRequest()
        xhr.open('GET', '../api/getGlobalLinks/' + orgId + '/' + planYear, false)
        xhr.send()
        if (xhr.readyState == 4 && xhr.status == 200) {
            return JSON.parse(xhr.responseText)
        }
        return JSON.parse(xhr.responseText)
    }

    getOrgIPV(orgId: number): Observable<number[]> {
        let getURL = '../api/GetOrgIPV/' + orgId + '/'
        return this.http.get<number[]>(getURL)
    }

    getHelpLocation(planYear: number): Observable<string> {
        let getURL = '../api/GetHelpLocation/' + planYear
        return this.http.get<string>(getURL)
    }
    getGoodStandingDetails(userProfileId: number, planYear: string): Observable<GoodStandingModel> {
        let getUrl = '../api/checkGoodStandingStatus/' + userProfileId + '/' + planYear + '/'
        return this.http.get<GoodStandingModel>(getUrl)
    }

    getIPVString(orgIPV: string): Observable<string> {
        let headers = new HttpHeaders()
        headers = headers.set('Content-Type', 'application/json')
        let params = new HttpParams().set('orgIPV', orgIPV)
        let getURL = '../api/GetIPVString/'
        return this.http.get<string>(getURL, { headers: headers, params: params })
        // let getURL = '../api/GetIPVString/' + orgIPV
        // return this.http.get<string>(getURL)
    }
}
